import { Component, Input, OnInit } from '@angular/core';
import { VmeCommonModule } from '../../vme-common.module';

@Component({
  selector: 'vehicle-reg',
  standalone: true,
  imports: [VmeCommonModule],
  templateUrl: './vehicle-reg.component.html',
  styleUrls: ['./vehicle-reg.component.scss'],
})
export class VehicleRegComponent {
  constructor() {}
}
